export type TravelCategory = "flights" | "cars" | "esim" | "experiences";

export type TravelWidgetConfig = {
  id: string;
  category: TravelCategory;
  titleFr: string;
  titleEn: string;
  descriptionFr: string;
  descriptionEn: string;
  scriptUrl?: string;
  minHeight: number;
  mode?: "widget" | "launch";
  launchPath?: string;
};

const tracking = "trs=501285&shmarker=705546";

export const TRAVEL_WIDGETS: TravelWidgetConfig[] = [
  {
    id: "flights",
    category: "flights",
    titleFr: "Vols et escapades",
    titleEn: "Flights and escapes",
    descriptionFr:
      "Comparez les options de vols au départ de Montréal et ajoutez un hébergement au besoin.",
    descriptionEn:
      "Compare flight options from Montreal and add a stay when needed.",
    scriptUrl: `https://tpwdg.com/content?currency=CAD&${tracking}&locale=fr&default_origin=YMQ&stops=any&show_hotels=true&powered_by=true&border_radius=14&plain=true&color_button=%2300A991&color_button_text=%23ffffff&promo_id=4478&campaign_id=111`,
    minHeight: 480,
  },
  {
    id: "cars",
    category: "cars",
    titleFr: "Location d’auto",
    titleEn: "Car rental",
    descriptionFr: "Comparez les options de location d’auto à Montréal.",
    descriptionEn: "Compare car rental options in Montreal.",
    mode: "launch",
    launchPath: "/explorer-plus?category=autos",
    minHeight: 340,
  },
  {
    id: "esim",
    category: "esim",
    titleFr: "eSIM voyage",
    titleEn: "Travel eSIM",
    descriptionFr:
      "Restez connecté dès votre arrivée avec une eSIM adaptée à votre destination.",
    descriptionEn:
      "Stay connected on arrival with an eSIM suited to your destination.",
    scriptUrl: `https://tpwdg.com/content?${tracking}&locale=fr&powered_by=true&color_button=%2300A991&color_focused=%2300A991&secondary=%23FFFFFF&dark=%230f172a&light=%23FFFFFF&special=%23C4C4C4&border_radius=14&plain=false&no_labels=true&promo_id=8588&campaign_id=541`,
    minHeight: 360,
  },
  {
    id: "experiences",
    category: "experiences",
    titleFr: "Activités et expériences",
    titleEn: "Activities and experiences",
    descriptionFr:
      "Réservez des activités et expériences locales à destination.",
    descriptionEn: "Book local activities and experiences at your destination.",
    scriptUrl: `https://tpwdg.com/content?currency=USD&${tracking}&locale=fr&city_id=107&category=3&amount=3&powered_by=true&campaign_id=137&promo_id=4497`,
    minHeight: 320,
  },
];

export const getTravelWidget = (category?: string) =>
  TRAVEL_WIDGETS.find((widget) => widget.category === category) ||
  TRAVEL_WIDGETS[0];
